module.exports = __webpack_public_path__ + "static/img/5-1-2.2c9f4205.png";